import { Box, Button } from "@chakra-ui/react";
import { FiChevronLeft } from "react-icons/fi";
import { RiSideBarLine } from "react-icons/ri";
import { useVerListagem } from "../contexts/VerListagemProvider";

export function ToggleVerListagemButton() {
  const { isOpen, setIsOpen } = useVerListagem();

  return (
    <Box className="leaflet-control leaflet-bar">
      <Button
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Ver Listagem"
      >
        <RiSideBarLine size={20} />
        <FiChevronLeft
          size={20}
          style={{
            transform: `rotate(${isOpen ? 0 : 180}deg)`,
            transition: "transform 0.3s"
          }}
        />
      </Button>
    </Box>
  );
}
